import Vue from 'vue';
import VueRouter from 'vue-router'
// import Index from "../index/Index.vue"
import Main from "../index/Main.vue"
import Login from "../login/Login.vue"
import Goods_Index from "../goods/Index.vue"
import Goods_Add from "../goods/Add.vue"
import Goods_Edit from "../goods/Edit.vue"
import Agent_Setup from "../agent/Setup.vue"
import Agent_Price from "../agent/price/Index.vue"

import Agent_Stat from "../agent/Statistical.vue"

import AgentUser_Add from "../agentuser/Add.vue"
import AgentUser_Index from "../agentuser/Index.vue"
import AgentUser_Edit from "../agentuser/Edit.vue"
import Purchase_Order from "../purchase_order/Index.vue"
import shopCart from "../shopCart/Index.vue"
import Order_My_Index from "../order/My_Index.vue"
import Order_Index from "../order/Index.vue"
import Order_User from "../order/Index_User"
import Order_Edit from "../order/edit"

import Order_Detail from "../order/Detail.vue"
import Category_Add from "../category/Add.vue"
import Order_Service from "../service/Index.vue"
import Withdrawal_Index from "../withdrawal/Index.vue"
import Order_Profits_Index from "../order_profits/Index.vue"
import Order_Profits_Detail from "../order_profits/Detail.vue"
import Password_Index from "../password/Index.vue"
import Agent_Password_Index from "../agent_password/Index.vue"
import Payment_Index from "../payment/Index.vue"
import Recharge_Index from "../recharge/Index.vue"
import Roles_Add from "../roles/Add"
import Attr from "../attr/Add.vue"
import product_group_index from "../product_group/Index"
import Express_Index from "../express/Index"
import Menu_Index from "../menu/Index"
import Menu_Add from "../menu/Add"
import urls from "../utils/urls"
import {post} from '../utils/http'

Vue.use(VueRouter)
const routes=[
  
    //单个路由均为对象类型，path代表的是路径，component代表组件
    {
        meta: {
            title: '管理后台',
            requireAuth:true
          },
         name:"admin",
         path:"/admin",
         component:Main,
         children:[
            {
                meta: {
                    title: '首页',
                    requireAuth:true
                  }, 
                name:"index",
                path:"index",
                // component:Index,
                component: resolve => require(['../index/Index.vue'], resolve)
             },
             {
                meta: {
                    title: '产品列表',
                    requireAuth:true
                  }, 
                  name:"goods_index",  
                path:"goods/index",
                component:Goods_Index,
             },
             {
                meta: {
                    title: '添加',
                    requireAuth:true
                  }, 
                  name:"goods_add",  
                  path:"goods/add",
                  component:Goods_Add,
             },
             {
              meta: {
                  title: '编辑',
                  requireAuth:true
                }, 
                name:"goods_edit",  
                path:"goods/edit/:id",
                component:Goods_Edit,
           },
			//代理商设置
			{   meta: {
                    title: '设置',
                    requireAuth:true
                  }, 
				name:"agent_setup",
				path:"agent/setup",
				component:Agent_Setup,
				
			},
			{
				meta:{
					title:'',
					requireAuth:true
				},
				name:"agent_price",
				path:"agent/price",
				component:Agent_Price,
				
			},
			
      {
				meta:{
					title:'添加代理商',
					requireAuth:true
				},
				name:"agent_user_add",
				path:"agent/user/add",
				component:AgentUser_Add
				
      },
      {
				meta:{
					title:'代理商列表',
					requireAuth:true
				},
				name:"agent_user_index",
				path:"agent/user/index",
				component: AgentUser_Index
				
      },
      {
				meta:{
					title:'代理商编辑',
					requireAuth:true
				},
				name:"agent_user_edit",
				path:"agent/user/edit/:id",
				component:AgentUser_Edit,
				
			},
     
      {
				meta:{
					title:'采购订单',
					requireAuth:true
				},
				name:"purchase_order",
				path:"purchase/user/index",
				component:Purchase_Order
				
      },
      {
				meta:{
					title:'购物订单',
					requireAuth:true
				},
				name:"shop_cart",
				path:"shopcart/user/index",
				component:shopCart
				
			},
      
      {
				meta:{
					title:'我的采购订单',
					requireAuth:true
				},
				name:"Order_My_Index",
				path:"order/user/my_index/:user_id?/:type?",
				component:Order_My_Index
				
      },
      {
				meta:{
					title:'订单详情',
					requireAuth:true
				},
				name:"order_detail",
				path:"order/user/detail/:id",
				component:Order_Detail
				
      },
      {
				meta:{
					title:'属性添加',
					requireAuth:true
				},
				name:"attr_add",
				path:"attr/index",
				component:Attr
				
      },
      {
				meta:{
					title:'添加分类',
					requireAuth:true
				},
				name:"category_add",
				path:"category/add",
				component:Category_Add
				
      },
      {
				meta:{
					title:'所有销售订单',
					requireAuth:true
				},
				name:"order_all_index",
				path:"order/user/all/index",
				component:Order_Index
				
      },
             {

                 meta:{
                     title:'用户采购订单',
                     requireAuth:true
                 },
                 name:"order_all_index",
                 path:"order/user/index",
                 component:Order_User

             },
             {

                 meta:{
                     title:'订单修改',
                     requireAuth:true
                 },
                 name:"order_edit",
                 path:"order/user/edit/:id",
                 component:Order_Edit

             },
			{
				meta:{
					title:'代理统计',
					requireAuth:true
				},
				name:"agent_stat",
				path:"agent/stat",
				component:Agent_Stat,
				
      },
      {
				meta:{
					title:'售后订单',
					requireAuth:true
				},
				name:"order_service",
				path:"order/user/service/index",
				component:Order_Service
				
      },
      {
        meta:{
          title:'提现明细',
          requireAuth:true
        },
        name:"withdrawal_index",
        path:"withdrawal/user/index",
        component:Withdrawal_Index,
        
        }, 
        {
          meta:{
            title:'销售订单',
            requireAuth:true
          },
          name:"order_profits_index",
          path:"order/user/profits/index/:status?",
          component:Order_Profits_Index
          
        }, 
        
        {
          meta:{
            title:'订单详情',
            requireAuth:true
          },
          name:"order_profits_detail",
          path:"order/profits/detail/:oid",
          component:Order_Profits_Detail 
          
        },
             {
                 meta:{
                     title:'快递列表',
                     requireAuth:true
                 },
                 name:"express_index",
                 path:"express/index",
                 component:Express_Index,

             },
        {
          meta:{
            title:'密码重置',
            requireAuth:true
          },
          name:"password_index",
          path:"account/password/index",
          component:Password_Index,
          
        },
             {
                 meta:{
                     title:'密码修改',
                     requireAuth:true
                 },
                 name:"agent_password_index",
                 path:"account/user/password/:user_id",
                 component:Agent_Password_Index,

             },
        {
          meta:{
            title:'收支明细',
            requireAuth:true
          },
          name:"payment_index",
          path:"payment/user/index",
          component:Payment_Index
          
        },
        {
            meta:{
                title:'用户充值',
                requireAuth:true
            },
            name:"recharge_index",
            path:"recharge/user/index",
            component:Recharge_Index,
        },
        {
                 meta:{
                     title:'角色管理',
                     requireAuth:true
                 },
                 name:"roles_add",
                 path:"roles/user/add",
                 component:Roles_Add,
         },
         {
                 meta:{
                     title:'商品组',
                     requireAuth:true
                 },
                 name:"product_group_index",
                 path:"product/group/index",
                 component:product_group_index,
         },
         {
             meta:{
                 title:'菜单列表',
                 requireAuth:true
             },
             name:"menu_index",
             path:"menu/index",
             component:Menu_Index,
         },
         {

             meta:{
                 title:'添加菜单',
                 requireAuth:true
             },
             name:"menu_add",
             path:"menu/add",
             component:Menu_Add,
         },
         ],
         redirect: "/admin/index"   
        },
    { 
        meta: {
        title: '管理员登陆'
       },
        name:"admin_login",
        path:"/admin/login",
        component:Login
      }
]

//实例化VueRouter并将routes添加进去
const router=new VueRouter({
    'mode':"history",
    //ES6简写，等于routes：routes
        routes
    });
    router.beforeEach((to, from, next) => {
        document.title = to.meta.title
        const requireAuth=to.meta.requireAuth
      
        if(requireAuth){
          
          checkverify(next,from);
        }else{

          next()
        }
       
      })   
    //抛出这个这个实例对象方便外部读取以及访问


    function checkverify(next,from){
      
      const user_data=localStorage.getItem("sh_admin_user_data")
      
      let json_data={}
      if(user_data!== null){
     
       json_data=JSON.parse(user_data)
      
       
      }
    
      
       post(urls.admin.login.getVerify,json_data).then((result)=>{
        
         const data=result 
       
        
         if(data.code==200){
           next()
           
     
         }else{
           console.log(from.fullPath)
           router.push({path:"/admin/login"})
           // next({
           //   name: 'user_login',
           //   query: {redirect: to.fullPath}
           //   })
         }
      
       
      
          
       });
     
     
     }
    export default router